import React from 'react';
import { Select, Divider, Input, Popconfirm, Row, Col, Space, Button, Tooltip, Popover, Tabs, Modal, message } from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet } from '../../actions';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import LayoutTemplates from '../../data/LayoutTemplates';
import LayoutPreview from './LayoutPreview';
import './LayoutTemplatesSelector.css';
import CustomizeLayoutPopup from '../popups/CustomizeLayoutPopup';

const { Option } = Select;
const { TabPane } = Tabs;
const { confirm } = Modal;

class LayoutTemplatesSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = { defaultTemplateDatas: [], templateDatas: [], selectedTemplate: -1 }
        const { setReloadTemplateHook = () => { } } = props;

        setReloadTemplateHook(this.reloadTemplates);
    }

    componentDidMount() {
        this.reloadDefaultTemplates().then(this.reloadTemplates);
    }

    componentDidUpdate(prevProps) {
        if ("value" in this.props && this.props.value !== prevProps.value) {
            this.reloadTemplates();
        }
    }

    reloadDefaultTemplates = () => {

        return new Promise((resolve, reject) => {

            const { usertoken, requestServerGet, brandid } = this.props;

            console.log("brandid " + brandid)
            requestServerGet("get_defaultlayouttemplates", { brandid: brandid }, null, (response) => {


                // console.log("get_defaultlayouttemplates")
                // console.log(JSON.stringify(response.data))

                // this.setState({ defaultTemplateDatas: LayoutTemplates.templates })
                this.setState({ defaultTemplateDatas: response.data }, () => resolve())
            }, usertoken)
        })
    }
    reloadTemplates = () => {

        return new Promise((resolve, reject) => {
            const { usertoken, requestServerGet, brandid } = this.props;

            requestServerGet("get_layouttemplates", { brandid: brandid }, null, (response) => {


                // console.log("get_defaultlayouttemplates")
                // console.log(JSON.stringify(response.data))

                // this.setState({ defaultTemplateDatas: LayoutTemplates.templates })
                this.setState({ templateDatas: response.data }, () => resolve())
            }, usertoken)
        });

    }

    filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }

    onChange = (value, selectedOptions) => {
        const { onChange } = this.props;
        onChange(value, selectedOptions);
    }

    onNameChange = event => {
        this.setState({
            newPlaylistName: event.target.value,
        });
    };

    applyTemplate = (template) => {
        // const { requestServerPost, usertoken, selectedBrandData, timelineData,  } = this.props;
        // const { Timelinelayouts } = timelineData;

        // const params = new FormData();

        // params.append("timelinelayoutid", Timelinelayouts.TLLID)
        // // params.append("duration", Timelinelayouts.)
        // params.append("layout", JSON.stringify(template));
        // params.append("brandid", selectedBrandData.BrandID)

        // requestServerPost("update_timelinelayout", params, {  }, (response) => {
        // }, usertoken);

        const { onTemplateNeedsApply = () => {
        } } = this.props;


        onTemplateNeedsApply(template)
    }

    deleteTemplate = (template) => {

        const { usertoken, requestServerPost } = this.props;

        requestServerPost("delete_layouttemplate", { layouttemplateid: template.LayoutTemplateID }, {}, () => {
            message.success(`Successfully deleted ${template.TemplateName}`);
            this.reloadTemplates();
        }, usertoken)
    }

    showCustomizePopup = (template) => {
        this.setState({ showCustomize: true, toCustomizeTemplate: template });
    }


    handleCustomizeOk = () => {
        this.setState({ showCustomize: false, toCustomizeTemplate: null });
    }

    handleCustomizeCancel = () => {
        this.setState({ showCustomize: false, toCustomizeTemplate: null });
    }

    onApplyLayoutTemplate = (customLayout) => {
        // this.setState({ currentLayout: JSON.stringify(customLayout), showCustomize: false });
    }

    render() {
        const { value, onSelect, onPlaylistCreated = () => { } } = this.props;

        const activeBGColor = "#a0dfff"
        const inactiveBGColor = "#fdfdfd"

        const deleteTemplateFunc = this.deleteTemplate;
        return (
            // <Cascader
            //     options={this.state.playlistOptions}
            //     onChange={this.onChange}
            //     placeholder="Select Playlist"
            //     showSearch={this.filter}
            // />

            <>


                <Modal
                    width={850}
                    title="CUSTOMIZE LAYOUT"
                    open={this.state.showCustomize}
                    footer={null}
                    onOk={this.handleCustomizeOk}
                    onCancel={this.handleCustomizeCancel}
                    destroyOnClose={true}
                >
                    <CustomizeLayoutPopup onApplyLayout={this.onApplyLayoutTemplate} onDiscard={this.handleCustomizeCancel} layout={this.state.currentLayout}></CustomizeLayoutPopup>
                </Modal>
                <Tabs defaultActiveKey="1" onChange={() => { }} className="layout-templates-tabs" >
                    <TabPane tab="System Templates" key="1" style={{ maxHeight: "282px", overflow: "auto" }}>
                        <Row justify="center" className="template-selector-row" style={{ width: "100%" }}>
                            {this.state.defaultTemplateDatas.map(layoutTemplate => {
                                const template = layoutTemplate.Template;

                                return (
                                    <Popconfirm title="Apply the selected template?" okText="Yes" cancelText="No" onConfirm={() => {
                                        this.applyTemplate(template)
                                    }}>

                                        <Col onClick={() => {
                                            // this.setState({ selectedTemplate: template.layout_id });
                                        }} className="center-content template-selector-col" style={{ width: "150px", height: "160px" }}>
                                            <Row>
                                                <Col className="center-content" span={24}>
                                                    <div className="center-content template-selector-item" style={{ width: "120px", height: "120px", backgroundColor: (template.layout_id === this.state.selectedTemplate) ? activeBGColor : inactiveBGColor, borderRadius: "4px", border: "2px solid #f0f0f0" }}>
                                                        <LayoutPreview size={100} layoutData={template}></LayoutPreview>
                                                    </div>
                                                </Col>
                                                <Col className="center-content" span={24}>
                                                    <div style={{ width: "100%", fontSize: "10px", fontWeight: 500, textAlign: "center", fontFamily: "Kanit", padding: "8px" }}>
                                                        {template.layout_name}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Popconfirm>
                                )
                            })}
                        </Row>
                    </TabPane>
                    <TabPane tab="User Templates" key="2" style={{ maxHeight: "282px", overflow: "auto" }}>
                        <Row justify="center" className="template-selector-row" style={{ width: "100%", height: "100%" }}>
                            {this.state.templateDatas.map(layoutTemplate => {
                                const template = layoutTemplate.Template;
                                return (
                                    <Col onClick={() => {
                                        // this.setState({ selectedTemplate: template.layout_id });
                                    }} className="center-content" style={{ width: "150px", height: "160px" }}>
                                        <Popover arrowPointAtCenter content={
                                            <Space size="small">
                                                <Button type="text" title="Edit" shape="circle" icon={<EditOutlined onClick={() => {
                                                    //  this.showCustomizePopup(template) 
                                                }} />}></Button>
                                                <Button type="text" title="Delete" shape="circle" onClick={
                                                    (event) => {
                                                        event.preventDefault();
                                                        confirm({
                                                            title: 'Do you want to delete this template?',
                                                            icon: <ExclamationCircleOutlined />,
                                                            onOk() {
                                                                return deleteTemplateFunc(layoutTemplate)
                                                            },
                                                            onCancel() { },
                                                        })
                                                    }


                                                } danger icon={<DeleteOutlined />
                                                }></Button>
                                            </Space>
                                        }>
                                            <Popconfirm title="Apply the selected template?" okText="Yes" cancelText="No" onConfirm={(event) => {
                                                event.preventDefault();
                                                this.applyTemplate(template)
                                            }}>
                                                <Row>
                                                    <Col className="center-content" span={24}>
                                                        <div className="center-content template-selector-item" style={{ width: "120px", height: "120px", backgroundColor: (template.layout_id === this.state.selectedTemplate) ? activeBGColor : inactiveBGColor, borderRadius: "4px", border: "2px solid #f0f0f0" }}>
                                                            <LayoutPreview size={100} layoutData={template}></LayoutPreview>
                                                        </div>
                                                    </Col>
                                                    <Col className="center-content" span={24}>
                                                        <div style={{ width: "100%", fontSize: "10px", fontWeight: 500, textAlign: "center", fontFamily: "Kanit", padding: "8px" }}>
                                                            {template.layout_name}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Popconfirm>
                                        </Popover>

                                    </Col>
                                )
                            })}
                        </Row>
                    </TabPane>
                    {/* <Modal
                    width={850}
                    title={null}
                    visible={this.state.showCreateTemplate}
                    footer={null}
                    onOk={this.handleCreateTemplateOk}
                    onCancel={this.handleCreateTemplateCancel}
                    destroyOnClose={true}
                >
                    <CreateLayoutTemplatePage template={JSON.parse(this.state.currentLayout)} onTemplateCreated={this.handleCreateTemplateOk}></CreateLayoutTemplatePage>
                </Modal> */}
                </Tabs>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage, requestNodeServerPost })(LayoutTemplatesSelector);